import Tab from "@mui/material/Tab";
import React, { Component } from "react";
import { withRouter } from "react-router";

import ConfirmationModalView from "../../organisms/ConfirmationModalView";
import ButtonView from "../ButtonView";
import FabView from "../FabView";

class ConfirmationButtonView extends Component {
  state = {
    isModalOpen: false,
    isLoading: false,
    errorMessage: null,
  };

  handleModalOpen = () => {
    this.setState({ isModalOpen: true });
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  handleSubmit = () => {
    const { onClick, onClickParameters, history, to, onClose, isAsync } =
      this.props;
    //World: onClickParameters? Jack: Yes...it's strange, but because of the async we need to pass it in like this.
    if (to) {
      //If routing then handle route
      this.handleModalClose();
      history.push(to);
    } else if (isAsync) {
      //If Async action then start loading, perform action
      this.setState({ isLoading: true });
      onClick(onClickParameters)
        .then((response) => {
          //If success stop loading and close modal
          this.setState({ isLoading: false });
          this.handleModalClose();
        })
        .catch((err) => {
          //If fail set error message (which ConfirmationModalView listens to)
          this.setState({ errorMessage: err, isLoading: false });
        });
    } else {
      //If not Async then just close modal and perform action
      this.handleModalClose();
      onClick(onClickParameters);
    }
  };

  render() {
    //NOTE: If loading needs to happen after the confirmation then add isAsync prop which is seen in this.handleSubmit.
    const {
      onClick,
      history,
      to, //Pulling these out so ButtonView doesn't receive them (the ButtonView just handles opening the modal)
      confirmationMessage,
      confirmationTitle,
      confirmationButtonText,
      isAcceptDisabled,
      isAcceptHidden,
      secondaryButtonText,
      secondaryButtonAtTop,
      customButtonBackgroundColor,
      isFab,
      isTab,
      children,
      isMobile,
      centerAcceptButton,
      leftTitleIconName,
      staticContext, // supresses React warning by not passing this to <Tab>
      ...rest
    } = this.props;

    const { isLoading } = this.state;
    return (
      <div>
        {isFab && <FabView {...rest} onClick={this.handleModalOpen} />}
        {isTab && <Tab {...rest} onClick={this.handleModalOpen} />}
        {!isFab && !isTab && (
          <ButtonView
            {...rest}
            onClick={this.handleModalOpen}
            customButtonBackgroundColor={customButtonBackgroundColor}
          />
        )}
        <ConfirmationModalView
          isOpen={this.state.isModalOpen}
          onAccept={this.handleSubmit}
          onClose={this.handleModalClose}
          title={confirmationTitle}
          message={confirmationMessage}
          confirmationButtonText={confirmationButtonText}
          isAcceptDisabled={isAcceptDisabled}
          isLoading={isLoading}
          errorMessage={this.state.errorMessage}
          isMobile={isMobile}
          isAcceptHidden={isAcceptHidden}
          secondaryButtonText={secondaryButtonText}
          secondaryButtonAtTop={secondaryButtonAtTop}
          customButtonBackgroundColor={customButtonBackgroundColor}
          centerAcceptButton={centerAcceptButton}
          leftTitleIconName={leftTitleIconName}
        >
          {children}
        </ConfirmationModalView>
      </div>
    );
  }
}

export default withRouter(ConfirmationButtonView);
